import { render } from "./CountOrder.vue?vue&type=template&id=640f35ee&scoped=true"
import script from "./CountOrder.vue?vue&type=script&lang=js"
export * from "./CountOrder.vue?vue&type=script&lang=js"

import "./CountOrder.vue?vue&type=style&index=0&id=640f35ee&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640f35ee"]])

export default __exports__